import { maintenanceDashboardPlugin } from './plugin';

export { maintenanceDashboardPlugin };

/**
 * The default export is what the app's feature discovery (`app.packages` in
 * `app-config.yaml`) installs.
 */
export default maintenanceDashboardPlugin;
